
import dynamic from "next/dynamic";
import { useState } from "react";

const FlashOff = dynamic(() => import("@/components/SVG/FlashOff"));
const FlashOn = dynamic(() => import("@/components/SVG/FlashOn"));

const FlashIcon = (props: {
  mediaTrackRef: React.MutableRefObject<MediaStreamTrack | null>
}) => {
  const mediaTrackRef = props.mediaTrackRef;

  const [isFlashOn, setIsFlashOn] = useState<boolean>(false);
  const toggleFlash = () => {
    mediaTrackRef.current?.applyConstraints({
      // @ts-ignore
      advanced: [{ torch: !isFlashOn }],
    });
    setIsFlashOn(!isFlashOn);
  }

  return <button onClick={toggleFlash} className="absolute bottom-6 left-6 w-8 h-8 border rounded-full p-1">
    {isFlashOn ? <FlashOn /> : <FlashOff />}
  </button>
}

export default FlashIcon;